<template>
    <div>
        <b-modal
                :no-close-on-backdrop="true"
                :ref="'form-create-company'"
                :id="'form-create-company'"
                :lazy="true"
                :title="isUpdate ? 'Organisatie bewerken' : 'Organisatie aanmaken'"
                size="xl"
                scrollable>
            <div>
                <div class="row mb-3">
                    <div class="col-md-5">
                        <formdata :form="form" :onlyImportant="false" :editable="false"></formdata>
                    </div>

                    <div class="col-md-7 border-hr border-left">
                        <div class="d-flex justify-content-between mb-2">
                            <div>
                                <strong class="sub-title d-block">Organisatie:</strong>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label col-form-label-sm">
                                Rechtsvorm:
                            </label>
                            <div class="col-sm-8">
                                <div class="row">
                                    <div class="col-12 col-sm-6" :class="isInvalid('org-legalForm')" v-for="legalForm in legalForms">
                                        <div class="form-check form-check-inline">
                                            <b-form-radio data-hj-whitelist class="form-check-input" :class="isInvalid('org-legalForm')" v-model="organisation.legalForm" :id="legalForm.key" :value="legalForm.value">{{legalForm.key}}</b-form-radio>
                                        </div>
                                    </div>
                                    <div v-if="isInvalid('org-legalForm')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['org-legalForm'].join(', ')}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="org-name" class="col-sm-4 col-form-label col-form-label-sm">
                                Naam: <i v-tooltip="'Vul hier de bedrijfsnaam in, of in het geval van een particuliere organisatie een overkoepelende naam. Zoals \'Bruidspaar Brink & Kok\' of \'Familie van Gaal\''" class="fas fa-info-circle text-muted"></i>
                            </label>
                            <div class="col-sm-8">
                                <input data-hj-whitelist :ref="'org-name'" type="text" class="form-control form-control-sm"
                                       v-model="organisation.name" :class="isInvalid('org-name')" id="org-name" placeholder="">
                                <div v-if="isInvalid('org-name')" class="invalid-feedback">
                                    {{this.validationErrors['org-name'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label col-form-label-sm">
                                Telefoonnummer:
                            </label>
                            <div class="col-sm-8 phone-input">
                                <vue-tel-input ref="org-phone" v-model="organisation.phone" :class="isInvalid('org-phone')" id="org-phone" placeholder="+31 xxxxxxxx" @onInput="validate" defaultCountry="nl"></vue-tel-input>
                                <div v-if="isInvalid('org-phone')" class="invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['org-phone'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="org-email" class="col-sm-4 col-form-label col-form-label-sm">
                                E-mailadres:
                            </label>
                            <div class="col-sm-8">
                                <input data-hj-whitelist type="email" class="form-control form-control-sm"
                                       v-model="organisation.email" :class="isInvalid('org-email')" id="org-email" placeholder="">
                                <div v-if="isInvalid('org-email')" class="invalid-feedback">
                                    {{this.validationErrors['org-email'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="org-kvk" class="col-sm-4 col-form-label col-form-label-sm">
                                KvK-nummer:
                                <small class="text-muted">(optioneel)</small>
                            </label>
                            <div class="col-sm-8">
                                <input data-hj-whitelist type="text" class="form-control form-control-sm"
                                       v-model="organisation.kvk" :class="isInvalid('org-kvk')" id="org-kvk" placeholder="">
                                <div v-if="isInvalid('org-kvk')" class="invalid-feedback">
                                    {{this.validationErrors['org-kvk'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="org-website" class="col-sm-4 col-form-label col-form-label-sm">
                                Website:
                                <small class="text-muted">(optioneel)</small>
                            </label>
                            <div class="col-sm-8">
                                <input data-hj-whitelist type="url" class="form-control form-control-sm"
                                       v-model="organisation.website" :class="isInvalid('org-website')" id="org-website" placeholder="">
                                <div v-if="isInvalid('org-website')" class="invalid-feedback">
                                    {{this.validationErrors['org-website'].join(', ')}}
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-4">
                                <strong>Adres:</strong>
                            </div>
                            <div class="col-8">
                                <hr />
                            </div>
                        </div>

                        <afas-address-input ref="address" id="address" v-model="organisation.address"></afas-address-input>

                        <div class="form-group row">
                            <div class="col-4">
                                <strong>Postadres:</strong>
                            </div>
                            <div class="col-8">
                                <hr />
                                <b-form-checkbox data-hj-whitelist v-model="organisation.samePostaddress" id="org-same-postaddress">Postadres is hetzelfde als het adres.</b-form-checkbox>
                            </div>
                        </div>

                        <afas-address-input ref="postaddress" v-if="!organisation.samePostaddress" id="postaddress" v-model="organisation.postaddress"></afas-address-input>
                    </div>
                </div>

            </div>
            <div slot="modal-footer" class="w-100">
                <div class="float-left">
                    <p class="text-muted">
                        <small>Bepaalde velden zijn al automatisch ingevuld op basis van de ontvangen gegevens.</small>
                    </p>
                </div>
                <div class="btn-group float-right">
                    <button class="btn btn-light" @click="hide">
                        Annuleren
                    </button>
                    <button class="btn btn-primary" @click="save">
                        Opslaan & Synchroniseren <i class="fas fa-check-circle"></i>
                    </button>
                </div>
            </div>
        </b-modal>

        <transition name="fade">
            <div class="custom-modal" v-show="showManualFixModal">
                <div class="custommodal-backdrop"></div>
                <div class="custom-modal-inner">
                    <div class="custom-modal-header">
                        <h5 class="modal-title">Los de onderstaande problemen op:</h5>
                        <button type="button" @click="showManualFixModal=false" aria-label="Close" class="close">×</button>
                    </div>
                    <div class="custom-modal-body detail-list">
                        <b-alert show variant="warning">
                            <strong>Bestaande {{ fixes.subjects.join(', ').replace(/,(?!.*,)/gmi, ' en ') }} gevonden</strong>
                            <p>Controleer of de gevonden resultaten overheen komen en kies of deze behouden moet(en) worden.</p>
                        </b-alert>

                        <step-indicator v-if="fixes.subjects.length > 1" :current="fixes.step - 1" :total="fixes.subjects.length" currentColor="#ffc107" defaultColor="#CCCCCC"></step-indicator>

                        <transition name="fade">
                            <div class="sub-group organisations mt-3" v-show="fixes.organisations && fixes.step === 1">

                                <div class="row">
                                    <div class="col-md-6">
                                        <strong>Ingevulde gegevens:</strong>
                                        <p>
                                            {{organisation.name}}<br />
                                            <strong>E-mailadres:</strong> {{organisation.email}}<br />
                                            <strong>Telefoonnummer:</strong> {{organisation.phone}}<br />
                                            <strong>KvK:</strong> {{organisation.kvk}}
                                        </p>
                                    </div>
                                    <div class="col-md-6 d-flex justify-content-center">
                                        <button @click="keepOrganisation()" class="btn btn-sm btn-light">Ingevulde organisatie behouden <i class="fas fa-chevron-right"></i></button>
                                    </div>
                                </div>

                                <h6><strong>Overeenkomsten:</strong></h6>

                                <div class="result-header">
                                    <div class="list-group list-group-flush mr-3">
                                        <div class="list-group-item">
                                            <div class="text-sm-left d-flex justify-content-between align-items-center">
                                                <div style="flex-grow: 2; flex-basis:0;"><strong>T</strong></div>
                                                <div style="flex-grow: 10; flex-basis:0;"><strong>Naam</strong></div>
                                                <div style="flex-grow: 10; flex-basis:0;"><strong>E-mailadres</strong></div>
                                                <div style="flex-grow: 5; flex-basis:0;"><strong>Telefoonnummer</strong></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="results">
                                    <div class="list-group list-group-flush">
                                        <a @click="finish(result)" v-for="result in fixes.data.organisations" class="list-group-item">

                                            <div class="d-flex justify-content-between align-items-center text-sm-left">
                                                <div style="flex-grow: 2; flex-basis:0;"><strong>{{result.type}}</strong></div>
                                                <div style="flex-grow: 10; flex-basis:0;">{{result.name ? result.name : '-'}}</div>
                                                <div style="flex-grow: 10; flex-basis:0;">{{result.email ? result.email : '-'}}</div>
                                                <div style="flex-grow: 5; flex-basis:0;">{{result.tel ? result.tel : '-'}}</div>
                                                <div>
                                                    <i class="fas fa-chevron-right"></i>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <transition name="fade">
                            <div class="sub-group addresses mt-3" v-show="fixes.addresses && fixes.step === 2">

                                <div class="row">
                                    <div class="col-md-6">
                                        <strong>Ingevuld adres:</strong>
                                        <p>
                                            {{organisation.address.street}} {{organisation.address.number}}{{organisation.address.number_addition}}<br />
                                            {{organisation.address.zip}} {{organisation.address.city}} {{organisation.address.country}}
                                        </p>
                                    </div>
                                    <div class="col-md-6 d-flex justify-content-center">
                                        <button @click="keepAddress()" class="btn btn-sm btn-light">Ingevuld adres behouden <i class="fas fa-chevron-right"></i></button>
                                    </div>
                                </div>

                                <h6><strong>Overeenkomsten:</strong></h6>

                                <div class="result-header">
                                    <div class="list-group list-group-flush mr-3">
                                        <div class="list-group-item">
                                            <div class="text-sm-left d-flex justify-content-between align-items-center">
                                                <div style="flex-grow: 2; flex-basis:0;"><strong>Type</strong></div>
                                                <div style="flex-grow: 10; flex-basis:0;"><strong>Adres</strong></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="results">
                                    <div class="list-group list-group-flush">
                                        <a @click="selectAddress(result)" v-for="result in fixes.data.addresses" class="list-group-item">
                                            <div class="d-flex justify-content-between align-items-center text-sm-left">
                                                <div style="flex-grow: 2; flex-basis:0;"><strong>{{result.type}}</strong></div>
                                                <div style="flex-grow: 10; flex-basis:0;">{{result.address ? result.address : '-'}}</div>
                                                <div>
                                                    <i class="fas fa-chevron-right"></i>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <transition name="fade">
                            <div class="sub-group postaddresses mt-3" v-show="fixes.postaddresses && fixes.step === 3">

                                <div class="row">
                                    <div class="col-md-6" v-if="organisation.postaddress">
                                        <strong>Ingevuld adres:</strong>
                                        <p>
                                            {{organisation.postaddress.street}} {{organisation.postaddress.number}}{{organisation.postaddress.number_addition}}<br />
                                            {{organisation.postaddress.zip}} {{organisation.postaddress.city}} {{organisation.postaddress.country}}
                                        </p>
                                    </div>
                                    <div class="col-md-6 d-flex justify-content-center">
                                        <button @click="keepPostaddress()" class="btn btn-sm btn-light">Ingevuld adres behouden <i class="fas fa-chevron-right"></i></button>
                                    </div>
                                </div>

                                <h6><strong>Overeenkomsten:</strong></h6>

                                <div class="result-header">
                                    <div class="list-group list-group-flush mr-3">
                                        <div class="list-group-item">
                                            <div class="text-sm-left d-flex justify-content-between align-items-center">
                                                <div style="flex-grow: 2; flex-basis:0;"><strong>Type</strong></div>
                                                <div style="flex-grow: 10; flex-basis:0;"><strong>Adres</strong></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="results">
                                    <div class="list-group list-group-flush">
                                        <a @click="selectPostaddress(result)" v-for="result in fixes.data.postaddresses" class="list-group-item" :key="result.id">
                                            <div class="d-flex justify-content-between align-items-center text-sm-left">
                                                <div style="flex-grow: 2; flex-basis:0;"><strong>{{result.type}}</strong></div>
                                                <div style="flex-grow: 10; flex-basis:0;">{{result.address ? result.address : '-'}}</div>
                                                <div>
                                                    <i class="fas fa-chevron-right"></i>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
    import formKeys from './../../helpers/formKeys';
    import afasAddressInput from './afasAddressInput';
    import StepIndicator from 'vue-step-indicator';
    import VueTelInput from 'vue-tel-input';

    export default {
        components: {
            afasAddressInput,
            VueTelInput,
            StepIndicator
        },
        data() {
            return {
                results: [],

                loaded: null,

                errors: [],
                validationErrors: [],

                q: '',

                organisation: {
                    address: {
                        country: 'NL',
                        street: '',
                        number: '',
                        number_addition: '',
                        zip: '',
                        city: ''
                    },
                    postaddres: {},
                    samePostaddress: true
                },

                defaultOrganisation: {},

                legalForms: [
                    {
                        value: "00",
                        key: "Privé persoon"
                    },{
                        value: "30",
                        key: "bv"
                    },{
                        value: "35",
                        key: "nv"
                    },{
                        value: "20",
                        key: "vof"
                    },{
                        value: "55",
                        key: "Stichting"
                    },{
                        value: "45",
                        key: "Vereniging"
                    },{
                        value: "05",
                        key: "Eenmanszaak"
                    },
                ],

                showManualFixModal: false,
                fixes: {
                    step: 1,
                    organisations: false,
                    addresses: false,
                    postaddresses: false,
                    subjects: [],
                    data: {
                        organisations: null,
                        addresses: null,
                        postaddresses: null
                    }
                },
                isUpdate: false
            }
        },
        props: {
            value: [Object, null],
            form: {
                type: Object,
                required: true,
            }
        },
        watch: {

        },
        mounted() {
            this.defaultOrganisation = Object.assign({}, this.organisation);
        },
        computed: {
        },
        methods: {
            mappedKey(key) {
                return formKeys.mapKey(key, key);
            },
            show (organisation = null) {
                this.$refs['form-create-company'].show();

                // If an organisation is passed to the show method,
                // use that organisation to prefill the form
                if (organisation) {
                    this.isUpdate = true;
                    this.setOrganisation(organisation);
                } else {
                    this.isUpdate = false;
                    this.organisation = this.defaultOrganisation;
                }

                // Using a timeout to make sure the modal is fully loaded.
                setTimeout(() => {
                    if (organisation) {
                        this.validate();
                    }

                    this.$refs['org-name'].focus();
                }, 200);
            },
            hide () {
                this.$refs['form-create-company'].hide();
                this.$emit('canceled');
            },
            select(result) {
                this.$emit('input', result);
                this.hide();
            },
            setOrganisation(organisation) {
                if (organisation.hasOwnProperty('tel')) {
                    organisation.phone = organisation.tel;
                }

                if (organisation.hasOwnProperty('legal_form')) {
                    organisation.legalForm = organisation.legal_form;
                }

                this.organisation = Object.assign(this.organisation, organisation);
            },
            validate() {
                let err = [];
                if(this.organisation.legalForm === undefined || this.organisation.legalForm === null) {
                    err['org-legalForm'] = [
                        'Kies een rechtsvorm!'
                    ];
                }
                if(this.organisation.name === undefined || this.organisation.name === null || this.organisation.name.length < 2) {
                    err['org-name'] = [
                        'Vul een geldige naam in, minimaal 1 teken.'
                    ];
                }
                if(this.organisation.phone === undefined || this.organisation.phone === null || !this.$refs['org-phone'].state) {
                    err['org-phone'] = [
                        'Vul een geldig telefoonnummer in.'
                    ];
                }
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(this.organisation.email === undefined || this.organisation.email === null || this.organisation.email.length < 2 || !re.test(this.organisation.email)) {
                    err['org-email'] = [
                        'Vul een geldig e-mailadres in.'
                    ];
                }
                if(this.organisation.kvk !== undefined && this.organisation.kvk !== null && this.organisation.kvk !== '' && this.organisation.kvk.length !== 8) {
                    err['org-kvk'] = [
                        'Een geldig kvk-nummer bestaat uit precies 8 cijfers.'
                    ];
                }
                if(this.organisation.website !== undefined && this.organisation.website !== null && !this.is_url(this.organisation.website)) {
                    err['org-website'] = [
                        'Dit is geen geldige website.'
                    ];
                }

                let validAddress = this.$refs.address.validate();
                let validPostAddress = (this.organisation.samePostaddress || this.$refs.postaddress.validate());
                this.validationErrors = err;
                return Object.keys(err).length === 0
                    && validAddress
                    && validPostAddress;
            },
            save() {
                if(this.validate()) {
                    this.$refs['form-create-company'].hide();

                    if (this.isUpdate) {
                        return this.update();
                    }

                    this.$swal({
                        title: 'Bezig met toevoegen',
                        html: 'We versturen nu de data...',
                        allowOutsideClick: false,
                        onOpen: () => {
                            this.$swal.showLoading()
                        }
                    });

                    axios.post('/api/v1/leads/afas/organisation', {
                        organisation: this.organisation,
                        form: this.form.id
                    })
                        .then(response => {

                            let steps = [];

                            this.fixes.organisations = (response.data.hasOwnProperty('organisations') && response.data.organisations.length > 0);
                            this.fixes.addresses = (response.data.hasOwnProperty('addresses') && response.data.addresses.length > 0);
                            this.fixes.postaddresses = (response.data.hasOwnProperty('postaddresses') && response.data.postaddresses.length > 0);

                            this.fixes.subjects = [];
                            if(this.fixes.organisations) {
                                this.fixes.subjects.push('organisatie(s)');

                                this.fixes.data.organisations = response.data.organisations;
                            }
                            if(this.fixes.addresses) {
                                this.fixes.subjects.push('adres(sen)');

                                this.fixes.data.addresses = response.data.addresses;
                            }
                            if(this.fixes.postaddresses) {
                                this.fixes.subjects.push('postadres(sen)');

                                this.fixes.data.postaddresses = response.data.postaddresses;
                            }

                            this.fixes.step = 1;
                            if(!this.fixes.organisations) {
                                if(!this.fixes.addresses) {
                                    this.fixes.step = 3;
                                } else {
                                    this.fixes.step = 2;
                                }
                            }
                            if(this.fixes.organisations || this.fixes.addresses || this.fixes.postaddresses) {
                                this.$refs['form-create-company'].show();
                                this.showManualFixModal = true;
                                this.$swal({
                                    type: 'warning',
                                    title: 'Bestaande ' + this.fixes.subjects.join(', ').replace(/,(?!.*,)/gmi, ' en ') +' gevonden',
                                    text: 'Controleer of de gevonden resultaten overheen komen en kies of deze behouden moet(en) worden.'
                                })
                            } else {
                                this.$swal({
                                    title: 'Succesvol toegevoegd',
                                    html: 'Nu nog even wachten totdat alles gesynchroniseerd is... <br />Huidige status: <strong>In afwachting van synchronisatie</strong>',
                                    allowOutsideClick: false,
                                    onOpen: () => {
                                        this.$swal.showLoading()
                                    }
                                });

                                this.checkJob(response.data.afas_nr, response.data.job_id);
                            }
                        })
                        .catch(error => {
                            this.$swal({
                                type: 'error',
                                showConfirmButton: false,
                                html: this.$errorMessage(error)
                            });
                        });
                }
            },
            update() {
                this.$swal({
                    title: 'Bezig met opslaan',
                    html: 'We versturen nu de data...',
                    allowOutsideClick: false,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });

                axios.put('/api/v1/leads/afas/organisation', {
                    organisation: this.organisation,
                    form: this.form.id
                })
                .then(response => {
                    this.$swal({
                        title: 'Succesvol opgeslagen',
                        html: 'Nu nog even wachten totdat alles gesynchroniseerd is... <br />Huidige status: <strong>In afwachting van synchronisatie</strong>',
                        allowOutsideClick: false,
                        onOpen: () => {
                            this.$swal.showLoading()
                        }
                    });

                    this.checkJob(response.data.afas_nr, response.data.job_id);
                });
            },
            checkJob(afasNr, jobId) {
                //request check
                axios.get('/api/v1/leads/afas/organisation/status/'+ jobId + '/' + afasNr)
                    .then(response => {
                        if(response.data.status === 'finished') {
                            this.$swal({
                                toast: true,
                                position: 'top',
                                type: 'success',
                                title: 'Opgeslagen en geselecteerd!',
                                showConfirmButton: false,
                                timer: 3000,
                                backdrop: false
                            });
                            this.finish(response.data.data);
                        } else if(response.data.status === 'failed') {
                            this.$swal(
                                'Mislukt!',
                                'De synchronisatie is mislukt. Meld dit samen met de volgende code: ' + jobId + '-' + afasNr,
                                'error'
                            ).then((result) => {
                                this.$emit('formDeleted')
                            })
                        } else {
                            let status = 'Onbekend';
                            switch (response.data.status) {
                                case 'queued':
                                    status = 'In de wachtrij';
                                    break;
                                case 'executing':
                                    status = 'Bezig met synchroniseren';
                                    break;
                            }
                            this.$swal.getContent().querySelector('strong')
                                .textContent = status;

                            setTimeout(() => {
                                this.checkJob(afasNr, jobId);
                            }, 1000);
                        }
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                    });
            },
            isInvalid(key) {
                if(this.validationErrors.hasOwnProperty(key)) {
                    return 'is-invalid';
                }
                return '';
            },
            is_url(str) {
                let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
                return regexp.test(str);
            },
            keepOrganisation() {
                this.organisation.force = true;
                if(this.fixes.addresses) {
                    this.fixes.step = 2;
                }
                else if(this.fixes.postaddresses) {
                    this.fixes.step = 3;
                }
                else {
                    this.showManualFixModal = false;
                    this.save();
                }
            },
            selectAddress(result) {
                this.organisation.address.id = result.address_nr;
                if(this.fixes.postaddresses) {
                    this.fixes.step = 3;
                }
                else {
                    this.showManualFixModal = false;
                    this.save();
                }
            },
            selectPostaddress(result) {
                this.organisation.postaddress.id = result.address_nr;

                this.showManualFixModal = false;
                this.save();
            },
            keepAddress() {
                this.organisation.address.force = true;
                if(this.fixes.postaddresses) {
                    this.fixes.step = 3;
                }
                else {
                    this.showManualFixModal = false;
                    this.save();
                }
            },
            keepPostaddress() {
                this.organisation.postaddress.force = true;
                this.showManualFixModal = false;
                this.save();
            },
            finish(organisation) {
                this.showManualFixModal = false;
                this.$refs['form-create-company'].hide();
                this.$emit('finished', organisation);
            }
        }
    }
</script>

<style lang="scss">
    .phone-input {
        * {
            outline: none;
        }
        .dropdown {
            padding: 4px;
        }
        ul {
            z-index: 1000;
            li {
                font-size: 0.8em;
            }
        }
    }
    .invalid-feedback-force {
        display: block;
    }

    .custom-modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1050;
        display: none;
        overflow: hidden;
        outline: 0;
        overflow-x: hidden;
        overflow-y: auto;
        display: block;
        .custommodal-backdrop {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1050;
            background-color: red;
            opacity: 0.5;
        }
        .custom-modal-inner {
            max-width: 99%;
            position: relative;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            width: 100%;
            pointer-events: auto;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 0.3rem;
            outline: 0;
            z-index: 1060;
            min-height: 300px;
        }
        .custom-modal-body {
            padding: 16px;
        }
        .custom-modal-header {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: start;
            -ms-flex-align: start;
            align-items: flex-start;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            padding: 1rem;
            border-bottom: 1px solid #e9ecef;
            border-top-left-radius: 0.3rem;
            border-top-right-radius: 0.3rem;
        }
        @media (min-width: 576px) {
            .custom-modal-inner {
                max-width: 500px;
                margin: 14% auto;
            }
        }
        @media (min-width: 900px) {
            .custom-modal-inner {
                max-width: 800px;
                margin: 1.75rem auto;
            }
        }
    }
</style>